import { Routes, Route } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Index } from '../pages/Index';
import { Jobs } from '../pages/Jobs';
import { JobDetails } from '../pages/JobDetails';
import { Login } from '../pages/Login';
import { Register } from '../pages/Register';
import { About } from '../pages/About';
import { Dashboard } from '../pages/Dashboard';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { ForgotPassword } from '../pages/ForgotPassword';
import { ResetPassword } from '../pages/ResetPassword';
import { CGU } from '../components/CGU';
import { PrivacyPolicy } from '../components/PrivacyPolicy';
import { RegistrationChoice } from '../components/registration/RegistrationChoice';
import { WorkerRegister } from '../components/worker/workerRegister';
import { Profile } from '../pages/Profile';
// import { ApplicationsPage } from '../pages/ApplicationsPage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Index />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/jobs/:id" element={<JobDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register/recruiter" element={<Register />} />
        <Route path="/register/worker" element={<WorkerRegister />} />
        <Route path="/about" element={<About />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
        <Route path="/register" element={<RegistrationChoice />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
          {/* <Route 
            path="/applications" 
            element={
              <ProtectedRoute>
                <ApplicationsPage />
              </ProtectedRoute>
            } 
          /> */}
      </Route>
    </Routes>
  );
}